export default {
  remote: 'f5_front_door_mfe',
  name: 'f5-front-door',
  source: 'https://github.com/telus/f5-front-door-mfe',
  urlMapping: {
    localhost: 'http://localhost:4321/mf-manifest.json',
    'simplify.developers.telus.digital':
      'https://assets.wcpreview.telus.com/1309204938/f5-front-door-mfe/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital':
      'https://assets.wcstage.telus.com/1309204938/f5-front-door-mfe/v1/mf2/mf-manifest.json',
    'simplify.telus.com':
      'https://assets.telus.com/1309204938/f5-front-door-mfe/v1/mf2/mf-manifest.json',
  },
};
